var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll",attrs:{"id":"testing-tools"}},[_c('HeaderTemplate',{attrs:{"data":_vm.contentHeader}}),_c('v-col',[_c('Sdk'),_c('Sandbox'),_c('TestTransactionSetup'),_c('GoingLive')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }